import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../components/ui/Button'
import Badge from '../components/ui/Badge'
import styles from './Home.module.css'

const PARTICLES = Array.from({ length: 20 }, (_, i) => ({
  id: i,
  left: `${Math.random() * 100}%`,
  delay: `${Math.random() * 8}s`,
  duration: `${6 + Math.random() * 6}s`,
}))

export default function Home() {
  return (
    <main className={styles.main}>
      <section className={styles.hero}>
        <div className={styles.particles} aria-hidden="true">
          {PARTICLES.map((p) => (
            <span key={p.id} className="particle" />
          ))}
        </div>
        <div className={styles.container}>
          <h1 className={styles.headline}>
            <span className="gradient-text">Verify</span> your identity even with a broken phone camera
          </h1>
          <p className={styles.sub}>
            Mirror your Android phone on your laptop and use your laptop webcam as the phone
            camera. Works with every verification app including Jumio and Onfido.
          </p>
          <div className={styles.ctas}>
            <Link to="/link">
              <Button size="lg">Get started</Button>
            </Link>
            <a
              href="/verifylink.apk"
              download
              className={styles.secondaryCta}
            >
              <Button variant="secondary" size="lg">
                Download Android app
              </Button>
            </a>
          </div>
        </div>
      </section>

      <section className={styles.howItWorks}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>How it works</h2>
          <ol className={styles.steps}>
            {[
              { num: '1', title: 'Install app', desc: 'Get the VerifyLink app on your Android phone.' },
              { num: '2', title: 'Pair devices', desc: 'Scan the QR code or enter the 6-digit code on your phone.' },
              { num: '3', title: 'Mirror phone', desc: 'See and control your phone screen from your laptop.' },
              { num: '4', title: 'Complete verification', desc: 'Use your laptop webcam as your phone camera.' },
            ].map((step) => (
              <li key={step.num} className={styles.step}>
                <span className={styles.stepNum} aria-hidden="true">{step.num}</span>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepDesc}>{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className={styles.privacy}>
        <div className={styles.container}>
          <div className={styles.privacyBanner}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <div>
              <h3 className={styles.privacyTitle}>Privacy-first by design</h3>
              <p className={styles.privacyText}>
                Files are encrypted before upload. Phone control is peer-to-peer.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.compatibility}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Works with</h2>
          <div className={styles.badges}>
            {['Jumio', 'Onfido', 'Stripe Identity', 'Veriff', 'Any KYC app'].map((name) => (
              <Badge key={name} variant="accent">{name}</Badge>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.trust}>
        <div className={styles.container}>
          <p className={styles.trustTitle}>Trusted by users worldwide</p>
          <div className={styles.trustLogos}>
            {['AES-256-GCM Encryption', 'Peer-to-Peer Video', '15-Minute Auto-Expiry', 'Zero-Knowledge Storage'].map((item) => (
              <span key={item} className={styles.trustItem}>{item}</span>
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}
